import Api from './api'

export default {

    get: function () {

        return Api.get('/v3/subscriptions')
    },

    delete: function (array) {

        return Api.post('/v3/subscriptions/delete', {'subscriptions': array})

    },

    unsubscribe: function (array) {

        return Api.post('/v3/subscriptions/block', {'subscriptions': array})

    },

    keep: function (array) {

        return Api.post('/v3/subscriptions/keep', {'subscriptions': array})

    },

    sortLater: function (array) {

        return Api.post('/v3/subscriptions/postpone', {'subscriptions': array})

    },

    blocked: function () {

        return Api.get('/v3/subscriptions/blocked')

    },
    kept: function () {

        return Api.get('/v3/subscriptions/kept')

    },
    getSortLater: function () {

        return Api.get('/v3/subscriptions/postponed')

    },

    unblock: function (array) {

        return Api.post('/v3/subscriptions/unblock', {'subscriptions': array})

    },

    release: function (array) {

        return Api.post('/v3/subscriptions/release', {'subscriptions': array})

    }

}
